import { Pipe, PipeTransform } from '@angular/core';
import { DeliveryNoteDiscrepancies } from '@app/shared/models/business-model/delivery-note-discrepancies';

@Pipe({ name: 'filterByDfn', })
export class FilterByDfnPipe implements PipeTransform {
    transform(items: DeliveryNoteDiscrepancies[], id: number): any[] {
        // console.log('+++++++++ filter array ++++++');
        // console.log(items);
        if (!items) {
            return [];
        }
        if (!id) {
            return items;
        }
        const result = items.filter(it => it.deliveryNoteId === id);
        // console.log('-------- filter result ---------');
        // console.log(result);
        return result;
    }
}
